export function toList<T>(o: { [uuid: string]: T }): T[] {
  return Object.values(o).filter(function (e) {
    return e !== undefined;
  });
}
